import { useState } from 'react';
import { i18n } from '@wms/shared';
import { api } from '../lib/api.js';

const { t } = i18n;

/**
 * Admin action: send a password-reset link to a user on their behalf (WMS-24).
 * Used on the partner and customer detail pages.
 */
export function UserPasswordResetButton({ userId, email }: { userId: string; email: string }) {
  const [state, setState] = useState<'idle' | 'busy' | 'sent' | 'failed'>('idle');

  async function send() {
    if (!confirm(`${t('user.reset.action')} — ${email}?`)) return;
    setState('busy');
    try {
      const r = await api<{ sent: boolean }>('/auth/password-reset/admin', {
        method: 'POST',
        body: { userId },
      });
      setState(r.sent ? 'sent' : 'failed');
    } catch {
      setState('failed');
    }
  }

  if (state === 'sent') {
    return <span className="text-xs text-emerald-600">{t('user.reset.sent')}</span>;
  }
  return (
    <button
      type="button"
      onClick={() => void send()}
      disabled={state === 'busy'}
      className="rounded border border-border px-2 py-1 text-xs hover:bg-muted disabled:opacity-50"
    >
      {state === 'failed' ? t('user.reset.failed') : t('user.reset.action')}
    </button>
  );
}
